"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = require("../../constants/Field");
var DataType_1 = require("../common/base/DataType");
var ComputeAttributes = /** @class */ (function () {
    function ComputeAttributes() {
        var _a;
        this.attributeDetails = (_a = {},
            _a[Field_1.FIELD.DATATYPE] = DataType_1.DataType.string,
            _a);
    }
    ComputeAttributes.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.LINK] = this.attributeDetails;
        json[Field_1.FIELD.OBJECTLINK] = this.attributeDetails;
        json[Field_1.FIELD.TIMEWINDOW] = this.attributeDetails;
        json[Field_1.FIELD.SAMPLINGWINDOW] = this.attributeDetails;
        json[Field_1.FIELD.SAMPLINGAGGREGATE] = this.attributeDetails;
        json[Field_1.FIELD.LIMIT] = this.attributeDetails;
        return json;
    };
    return ComputeAttributes;
}());
exports.ComputeAttributes = ComputeAttributes;
//# sourceMappingURL=ComputeAttributes.js.map